import ApiService from "../ApiService"

class AccessLinkService extends ApiService {
  /**
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super(`${process.env.VUE_APP_CONTEST_API}api/v1/access-link`, parameters)
  }

  /**
   * @param {string} email
   * @return {Promise<{data: Destination[]}>}
   */
  sendAccessLinkRequest(email) {
    return this.removeParameters()
      .submit("get", `${this.endpoint}/${encodeURIComponent(email)}`)
      .then(res => {
        return res.data
      })
  }
}

export default AccessLinkService
